import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import LabTabs from './LabTabs';
import ClientProvider from './client';
export default createDemo(import.meta.url, LabTabs, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/tabs/demos/lab/LabTabs.tsx",
    "fileName": "LabTabs.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Tab from '@mui/material/Tab';\nimport TabContext from '@mui/lab/TabContext';\nimport TabList from '@mui/lab/TabList';\nimport TabPanel from '@mui/lab/TabPanel';\n\nexport default function LabTabs() {\n  const [value, setValue] = React.useState('1');\n\n  const handleChange = (event: React.SyntheticEvent, newValue: string) => {\n    setValue(newValue);\n  };\n\n  return (\n    <Box sx={{ width: '100%', typography: 'body1' }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <TabContext value={value}>\n        <TabList\n          onChange={handleChange}\n          aria-label=\"lab tabs\"\n          sx={{ borderBottom: 1, borderColor: 'divider' }}\n        >\n          <Tab label=\"Item One\" value=\"1\" />\n          <Tab label=\"Item Two\" value=\"2\" />\n        </TabList>\n        <TabPanel value=\"1\" tabIndex={0}>\n          Item One\n        </TabPanel>\n        <TabPanel value=\"2\" tabIndex={0}>\n          Item Two\n        </TabPanel>\n      </TabContext>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Box>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 35,
        "focusedLines": 16,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Tab from '@mui/material/Tab';\nimport TabContext from '@mui/lab/TabContext';\nimport TabList from '@mui/lab/TabList';\nimport TabPanel from '@mui/lab/TabPanel';\n\nexport default function LabTabs() {\n  const [value, setValue] = React.useState('1');\n\n  const handleChange = (event: React.SyntheticEvent, newValue: string) => {\n    setValue(newValue);\n  };\n\n  return (\n    <Box sx={{ width: '100%', typography: 'body1' }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <TabContext value={value}>\n        <TabList\n          onChange={handleChange}\n          aria-label=\"lab tabs\"\n          sx={{ borderBottom: 1, borderColor: 'divider' }}\n        >\n          <Tab label=\"Item One\" value=\"1\" />\n          <Tab label=\"Item Two\" value=\"2\" />\n        </TabList>\n        <TabPanel value=\"1\" tabIndex={0}>\n          Item One\n        </TabPanel>\n        <TabPanel value=\"2\" tabIndex={0}>\n          Item Two\n        </TabPanel>\n      </TabContext>\n"
      ],
      [
        "span",
        "frame",
        "    </Box>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 17
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "TabContext"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "value"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 18
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "TabList"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 19
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "onChange"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleChange"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 20
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "lab tabs",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "sx"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "borderBottom"
              ],
              ": ",
              [
                "span",
                "pl-c1 di-num",
                "1"
              ],
              ", ",
              [
                "span",
                "di-op di-jv",
                "borderColor"
              ],
              ": ",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "divider",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            "        >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Tab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Item One",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "1",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "          <",
              [
                "span",
                "pl-c1 di-jsx",
                "Tab"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Item Two",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "2",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "TabList"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "TabPanel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "1",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "tabIndex"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "0"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            "          Item One"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "TabPanel"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "TabPanel"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "2",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "tabIndex"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "0"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            "          Item Two"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            [
              "        </",
              [
                "span",
                "pl-c1 di-jsx",
                "TabPanel"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 32
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "TabContext"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 35,
    "focusedLines": 16,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Tab",
      "@mui/lab/TabContext",
      "@mui/lab/TabList",
      "@mui/lab/TabPanel"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
